import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/footer/ftlink5.png")